<div ngCloak>
    <div id="wallboardViewArea">
        <div #main></div>
        <cv-loader size="large" [overlay]="true" *ngIf="isLoading && !hasError"></cv-loader>
    </div>

    <!--I'm not using [hidden] on the preRender becuse display: hidden removes the element from the DOM flow and height and width calculate to 0, 
        preventing the calculations needed for sizing certain elements from working correctly. Using Visibility and opacity instead fixes that problem--> 
    <div class="visibility-hidden">
        <div #preRender></div>
    </div>
</div>
